import {
    SYSTEM_CHOOSE_CURRENT_CERTTYPE,
} from './constants';
  
export function chooseCurrentCertType(modal) {
    return {
      type: SYSTEM_CHOOSE_CURRENT_CERTTYPE,
      data: modal,
    };
}
  
export function reducer(state, action) {
    switch (action.type) {
      case SYSTEM_CHOOSE_CURRENT_CERTTYPE:
        return {
          ...state,
          currentCertType:action.data,
        };
  
      default:
        return state;
    }
}


// WEBPACK FOOTER //
// ./src/features/system/redux/chooseCurrentCertType.js